export enum FteValue {
    ONE = 1,
    HALF = 0.5,
    REVIEWER_OR_QA = 0,
}
